import { render, staticRenderFns } from "./cityGroupList.vue?vue&type=template&id=64e161bc&scoped=true"
import script from "./cityGroupList.vue?vue&type=script&lang=js"
export * from "./cityGroupList.vue?vue&type=script&lang=js"
import style0 from "./cityGroupList.vue?vue&type=style&index=0&id=64e161bc&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e161bc",
  null
  
)

export default component.exports